import Dropdown from "../Dropdown";
import { projectMenus } from "../ProjectMenus";

export default function QualityMenu(props) {
  return (
    <Dropdown
      menuKey="quality"
      menu={projectMenus.quality}
      {...props}
    />
  );
}
